import React, {useEffect, useState} from 'react';
import {Site} from "types/Site";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "context/OperatorContext";
import {useNotifications} from "context/NotificationContext";

type Props = {
    site: Site | null
    show: boolean
    onDelete?: (site: Site) => any
    onDeleteFail?: (site: Site, error: unknown) => any
    onCancel?: () => any
}

function DeleteSite(props: Props) {
    const {site, show, onDelete, onDeleteFail, onCancel} = props

    const {termFor} = useOperator()
    const {notify} = useNotifications()

    const [name, setName] = useState<string>(site?.name || `this ${termFor('site')}`);
    const {mutateAsync: deleteSite} = useMutation(ngage.sites.destroy)

    useEffect(() => {
        if(site) setName(site.name)
    }, [site]);

    async function handleDeleteSite() {
        if (site) {
            try {
                await deleteSite(site.id)
                await invalidate('sites.all')

                notify("success", `${termFor('Site')} Deleted`, `${site.name} has been permanently removed`)
                if (onDelete) onDelete(site)
            } catch (error) {
                notify("error", `${termFor('Site')} Not Deleted`, `${site.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(site, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Site')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteSite}
            onCancel={handleCancel}
        />
    );
}

export default DeleteSite;